import React from "react";
import { Modal } from "react-bootstrap";
import useTranslator from "../../hooks/useTranslator";

const AwardPropertyPopup = ({ awardPopupModal, setAwardPopupModal }) => {
  const { _t } = useTranslator();

  return (
    <Modal
      show={awardPopupModal}
      className="metermodal modal-xl custom-modal-popup"
      centered
      onHide={() => setAwardPopupModal(false)}
    >
      <Modal.Header closeButton><h2>
            {_t(
              "awardProperty",
              "Award property popup heading.."
            )}
          </h2></Modal.Header>
      <Modal.Body >
        <div className="bodyContentset">
          
          <form onSubmit={(e) => e.preventDefault()}>
            <div className="forminput row100 bodyContentset">
              <label className="forminput forminput2">
                {_t("Rent Price", "Award property popup form label")}
              </label>
              <input
                type="text"
                name="Rent Price"
                placeholder={_t(
                  "Enter Rent Price",
                  "Award property popup form placeholder"
                )}
                onChange={(e) => {}}
              />
            </div>
            <div className="forminput row100 bodyContentset">
              <label className="forminput forminput2">
                {_t("Number Of Deposit Month", "Award property popup form label")}
              </label>
              <input
                type="text"
                name="Enter months"
                placeholder={_t(
                  "Enter months",
                  "Award property popup form placeholder"
                )}
                onChange={(e) => {}}
              />
            </div>
            <div className=" row100 gridbar popup_btn2">
              <button className="btn btngreen display-block w-100" type="submit">
                {_t("submit")}
              </button>
            </div>
          </form>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default AwardPropertyPopup;
